import React, { useState } from "react";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

import { HomeConfig } from "config/homeConfig";
import { COLOR } from "config/color";
import { ModalStyle, WhiteButton } from "components/Styled";
import * as ga from "methods/ga";

import { HeaderWrapper } from "./styled";
import { Box, Modal } from "@mui/material";
import { ModalContent } from ".";
import { useAuth } from "providers/Auth";

export default function Header() {
  const [modalOpen, setOpen] = useState("");
  const {
    auth: { userId },
    userVerify,
  } = useAuth();

  const goForm = () => {
    if (userVerify === "UNAUTHORIZED")
      document
        .getElementById("la-prairie-form")
        .scrollIntoView({ behavior: "smooth" });
    else setOpen("submited");
    ga.sendGAEvent(userId, ga.GaEventType.EXPERIENCE);
    ga.gtmButtonClick(ga.ButtonType.BUY);
  };
  const goProduct = () => {
    window.open(HomeConfig.header.link);
  };
  return (
    <>
      <HeaderWrapper>
        <img alt="header-img" src={HomeConfig.header.img} />
        <div className="banner_content">
          <img className="logo" src={HomeConfig.header.logo} alt="logo" />
          <div className="title">{HomeConfig.header.title}</div>
          <div className="subtitle">{HomeConfig.header.subtitle}</div>
          <WhiteButton
            variant="outlined"
            sx={{
              marginBottom: "13px",
              fontSize: "1.2rem",
              padding: "2px 1.5rem",
              background: "transparnt",
              color: "white",
              borderColor: "white",
            }}
            onClick={goForm}
          >
            {ga.ButtonType.BUY}
          </WhiteButton>
          {/* <div className="more" onClick={goProduct}>
            探索更多
          </div>
          <KeyboardDoubleArrowDownIcon color="disabled"></KeyboardDoubleArrowDownIcon> */}
        </div>
      </HeaderWrapper>
      <Modal open={!!modalOpen}>
        <Box sx={ModalStyle}>
          <ModalContent type={modalOpen} setExchangeModal={setOpen} />
        </Box>
      </Modal>
    </>
  );
}
